import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VideoLibraryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"video_library"}/>
}
